import { useEffect, useRef } from "react";
import type { Permissions } from "@/features/auth/models/permissions";

import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { useRemoveSelections } from "@/features/betslip/hooks/useBetslipActions";

/** Drops selections a permission change invalidated - an exotic once the
 *  exotic permission goes. Only fires on the change itself. */
export const useAutoPruneByPermissions = () => {
  const permissions = useBetslipStore((state) => state.permissions);
  const removeSelections = useRemoveSelections();

  const lastPermissionsRef = useRef<Permissions | null>(null);

  useEffect(() => {
    if (!permissions) return;
    if (permissions === lastPermissionsRef.current) return;
    lastPermissionsRef.current = permissions;

    const toDrop = [...useBetslipStore.getState().disallowedOutcomeIds];
    if (toDrop.length) removeSelections(toDrop);
  }, [permissions, removeSelections]);
};
